import React from 'react';
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';

const Menu2 = (props) => {
    const { t } = useTranslation();

    return (
        <>
          <nav className="navbar navbar-default navbar-primary navbar-theme navbar-theme-full navbar-theme-border btn-shadow2">
                <div className="container">
                    <div className="navbar-inner nav container">
                        <div className="navbar-header">
                            <button className="navbar-toggle collapsed" data-target="#navbar-main" data-toggle="collapse" type="button" aria-expanded="false">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            <a href="https://www.avior.com.ve/" rel="noopener noreferrer nofollow">
                                <img src={`${process.env.PUBLIC_URL}/img/logo.png`} className="_pt-15 _pl-15 _w-40pct" alt="logo" />
                            </a>
                        </div>
                        <div className="collapse navbar-collapse" id="navbar-main">
                            <ul className="nav navbar-nav"></ul>
                            <ul className="nav navbar-nav navbar-right" style={{ display: 'flex', alignItems: 'center' }}>
                                <li className="navbar-nav-item-user">
                                    <a title={t('menu.inicio', 'Inicio')} href="https://www.avior.com.ve/" rel="noopener noreferrer nofollow">
                                        {t('menu.inicio', 'Inicio')}
                                    </a>
                                </li>
                                <li className="navbar-nav-item-user">
                                    <a title={t('menu.destinos', 'Destinos')} href="https://www.avior.com.ve/destinos" rel="noopener noreferrer nofollow">
                                        {t('menu.destinos', 'Destinos')}
                                    </a>
                                </li>
                                <li className="navbar-nav-item-user">
                                    <a title={t('menu.consultar', 'Consultar')} href="/" rel="noopener noreferrer nofollow">
                                        {t('menu.consultar', 'Consultar')}
                                    </a>
                                </li>
                                <li className="navbar-nav-item-user" style={{ marginLeft: '15px' }}>
                                    <LanguageSwitcher />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav> 
        </>
    );
}

export default Menu2;